<template>
        <!-- InfoPOPUP -->
        <v-layout  row justify-center>
            <v-dialog v-model="mustShowInfoPopup" content-class="display-info-popup"
                      persistent max-width="600"
                      id="close-popup"
                      scrollable
                      v-bind="dialogBindings">
                <v-card class="no-padding info-popup show-info-popup border-color-invisible">
                    <v-card-title v-if="!isAssessmentPfi" class="headline color-on-primary-text bg-color-primary border-bottom-block">
                        <span class="font-weight-bold">{{text('api.info.popup.title')}}</span>
                        <span  @click="closeInfoPopup()" class="float-right cursor-pointer">
                            <close-icon />
                        </span>
                    </v-card-title>
                    <v-card-title v-else class="component-bg-color border-bottom-block" style="justify-content: center">
                        <span  @click="closeInfoPopup()" class="float-left cursor-pointer"  style="position: absolute;left: 15px; top: 15px;">
                            <close-icon :svg-fill-class="'svg-secondary-color'" />
                        </span>
                        <span class="font-weight-bold" style="font-size: 16px;">{{text('api.info.popup.title')}}</span>
                    </v-card-title>
                    <v-card-text
                        class="padding-s component-bg-color" v-if="getMedicalDeviceInfoPopupData">
                        <div>
                            <h4>{{getMedicalDeviceInfoPopupData.productName}}</h4>
                            <span>
                                <md-icon />
                                <ce-icon />
                            </span>
                        </div>

                        <div v-if="getMedicalDeviceInfoPopupData.supportAddress">
                            <support-icon />
                            <p v-html="getMedicalDeviceInfoPopupData.supportAddress"></p>
                        </div>

                        <div>
                            <manufacturer-icon />
                            <p v-html="getMedicalDeviceInfoPopupData.manufacturerAddress" style="white-space: pre-line;"></p>
                        </div>

                        <div v-if="getMedicalDeviceInfoPopupData.ecRepDisplay">
                            <authorized-representative-icon />
                            <p v-html="getMedicalDeviceInfoPopupData.ecRepAddress" style="white-space: pre-line;"></p>
                        </div>

                        <div>
                            <date-of-manufacture-icon />
                            <p>{{getMedicalDeviceInfoPopupData.buildDate}}</p>
                        </div>

                        <div>
                            <udi-icon />
                            <p>{{getMedicalDeviceInfoPopupData.uid}}</p>
                        </div>

                    </v-card-text>

                    <v-card-actions v-if="!isAssessmentPfi" class="float-right info-popup-btn-actions">
                        <div class="continue">
                            <v-btn flat @click="closeInfoPopup()" >{{text('api.button.close')}}</v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import MdIcon from "../svg/info-popup/mdIcon";
import CeIcon from "../svg/info-popup/ceIcon";
import SupportIcon from "../svg/info-popup/supportIcon";
import ManufacturerIcon from "../svg/info-popup/manufacturerIcon";
import AuthorizedRepresentativeIcon from "../svg/info-popup/authorizedRepresentativeIcon";
import DateOfManufactureIcon from "../svg/info-popup/dateOfManufactureIcon";
import UdiIcon from "../svg/info-popup/udiIcon";
import CloseIcon from "../svg/shared/closeIcon";
import ManualIcon from "../svg/shared/manualIcon";

export default {
        name: 'InfoPopup',
    components: {
        ManualIcon,
        CloseIcon,
        UdiIcon,
        DateOfManufactureIcon, AuthorizedRepresentativeIcon, ManufacturerIcon, SupportIcon, CeIcon, MdIcon},
    computed: {
            ...mapGetters({
                getMedicalDeviceInfoPopupData: 'MedicalDeviceInfoStore/getMedicalDeviceInfoPopupData',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),
            isAssessmentPfi() {
                return this.$route.name === 'PF_AssessmentPage' ||  this.$route.name === 'PF_ChatBotEvaluationPage'
            },
            dialogBindings () {
                if (this.isAssessmentPfi) {
                    return {
                        transition: 'dialog-bottom-transition'
                    }
                }
                return;
            }

        },

        mounted() {

        },

        methods: {

            closeInfoPopup() {
                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                this.PfChatbotPlugin.showScroll();
            },

            handleKeyDowns(evt) {

                if (this.mustShowUrgentPopup === false) {
                    return;
                }

                if (evt.repeat === true) {
                    // Prevent handling the event multiple times if the user holds the key pressed.
                    return;
                }

            },

            handleKeyUps(evt) {

                switch (evt.keyCode) {

                    // Tab
                    case 9:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false;

                }

                switch (evt.keyCode) {

                    case 27:
                        // Escape
                        this.closeInfoPopup();
                        break;

                }
            },
        },

        created: function() {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function() {
            document.removeEventListener('keydown', this.handleKeyDowns);
            document.removeEventListener('keyup', this.handleKeyUps);
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/shared/InfoPopup.vue